import React, { useCallback } from 'react';
import { TChannelOption } from '../../../api/endpoints/SubsetOption';
import Checkbox from '../../Inputs/Checkbox/Checkbox';
import Index from '../../Ui/CheckboxWrap';
import SelectAllControl from "../SelectAllControl";

const ChannelsSelector = (props: {
  values: Array<number>;
  spec: TChannelOption;
  onChange: (values: Array<number>) => void;
}) => {
  const { spec, values, onChange } = props;

  const options = spec.value.channel.map(channel => parseInt(channel, 10));

  const onStepCheckboxChange = useCallback((value: number, checked: boolean) => {
    onChange(checked ? [...values, value] : values.filter(v => v !== value));
  }, [onChange, values]);

  return (
    <div>
      <SelectAllControl onChange={onChange} values={options} className="margin-bottom-xs" />

      <Index>
        {
          options.map(option =>
            <Checkbox
              key={option}
              label={option.toString()}
              value={option}
              checked={values.includes(option)}
              name="channels"
              onChange={(checked) => onStepCheckboxChange(option, checked)}
            />)
        }
      </Index>
    </div>
  );
};

export default ChannelsSelector;
